import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Menubar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalConfig, NavigationPreloadData } from 'interfaces/interfaces';
import { ScrollToAnchor } from './ScrollToAnchor';
import { SidebarComponent } from './Sidebar';

interface Props {
	cfg: GlobalConfig;
	preloadData: NavigationPreloadData[];
}

export default observer(function NavigationApp(props: Readonly<Props>) {
	const { t } = useTranslation();

	const [showSidebar, setShowSidebar] = useState(false);
	const [menu, setMenu] = useState<MenuItem[]>([]);
	const sidebarMenu = menu.length ? [menu[menu.length - 1], ...menu.toSpliced(menu.length - 1, 1)] : [];

	useEffect(() => {
		const items: MenuItem[] = [];
		props.preloadData?.[0]?.result?.forEach((navigation) => {
			const highlightNavItem =
				props.cfg.deliveryInfo.content?.oid === navigation.id ||
				props.cfg.deliveryInfo.navigations.some((nav) => nav.oid === navigation.id);

			items.push({
				label: navigation.name,
				url: navigation.url,
				className: classNames({ active: highlightNavItem }),
			});
		});

		items.push({ label: 'Mein HOFER GRÜNSTROM', url: '/app/', className: 'customer-login' });
		setMenu(items);
	}, [props.preloadData]);

	return (
		<>
			<nav className="app-navigation">
				<div className="navigation-top">
					<div className="left">
						<a className="logo-hofer" href="/">
							<img src="/assets/img/brand/logo-hofer.svg" alt={t('navigation.logo.alt')} />
						</a>
					</div>
					<div className="right">
						<a className="logo-gruenstrom" href="/">
							<img src="/assets/img/brand/logo.png" alt={t('navigation.logo-gruenstrom.alt')} />
						</a>
					</div>
				</div>
				<div className="navigation-bottom">
					<div className="mobile-menu">
						<div className="mobile-menu-buttons-wrapper">
							<button className="burger button default" onClick={() => setShowSidebar((show) => !show)}>
								<span>{t('navigation.menu.navigation.label')}</span>
							</button>
						</div>
					</div>
					<Menubar className="desktop-menu" model={menu} />
				</div>
				<SidebarComponent menu={sidebarMenu} visible={showSidebar} hide={() => setShowSidebar(false)} />
				<ScrollToAnchor />
			</nav>
		</>
	);
});
